import { render, staticRenderFns } from "./PromotionStep.vue?vue&type=template&id=68a87cbd&scoped=true"
import script from "./PromotionStep.vue?vue&type=script&lang=js"
export * from "./PromotionStep.vue?vue&type=script&lang=js"
import style0 from "./PromotionStep.vue?vue&type=style&index=0&id=68a87cbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a87cbd",
  null
  
)

export default component.exports